import { IonButton, IonButtons, IonCard, IonCardHeader, IonCardTitle, IonContent, IonHeader, IonicSlides, IonImg, IonItem, IonLabel, IonList, IonListHeader, IonTitle,  IonToolbar } from '@ionic/react';
import React, {  useState } from 'react';
import { IonIcon } from '@ionic/react';
import { alarmSharp, linkSharp, medalSharp,locationOutline,listOutline,timeOutline,globeOutline,pricetagOutline,megaphoneOutline} from 'ionicons/icons';
import { PMagicoProps } from '../interfaces';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';


// import required modules

import closePage from '../assets/close-circle.svg'
import location_white from '../assets/location-pin.svg'

import { useTranslation } from 'react-i18next';

//Estilos de cada carta
import './PMagicoModal.css'


const PMagicoModal = ({
    marker,
    onDismiss,
  }: {
    marker : PMagicoProps;
    onDismiss: () => void;
  }) => {
    const [t,i18n] = useTranslation("global");
    
    return (
        <>
           <IonHeader className='museo-ion-header'>
          <IonToolbar className='name-header-modal1 toolbar-modal-museo'>
              <IonButtons className='button-close'>
                <IonButton className='text-close-museo' onClick={() => onDismiss()}>
                  <img src={closePage} alt="imageClose" id='icon-close' />
                </IonButton>
              </IonButtons>
              <Swiper
                // spaceBetween={5}
                modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
                autoplay={true}
                keyboard={true}
                pagination={{
                  dynamicBullets: true,
                }}
                scrollbar={true}
                zoom={true}
                slidesPerView={1}
                onSlideChange={() => console.log('slide change')}
                onSwiper={(swiper) => console.log(swiper)}
              >
              {marker.urlImagen.map((element, index) => 
            <>
              <SwiperSlide>
                <IonCard id='swiper-ioncard'>
                <img className="img-swiper" alt='{marker.nombre}' src={element} onError={(e) => {
  e.currentTarget.onerror = null; 
  e.currentTarget.src = 'https://mexicoprofundo.app/fallback-imgs/collage-fallback.png';
}}
/>
                  <IonCardHeader>
                    <IonCardTitle>{marker.municipio}</IonCardTitle>
                  </IonCardHeader>
                </IonCard>
              </SwiperSlide>
                </>
              )
              }
              </Swiper>
            <IonTitle>
            <div className="title">
                    <div className="localidad">
                        <div className="icon-loc">
                            <IonImg
                                src={location_white}            
                                alt="Location_white"
                            ></IonImg>
                        </div>
                        <div className="lugar">
                            {marker.nombre}
                        </div>
                    </div>
                </div>
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        
        <IonContent fullscreen={true} className="ion-padding">
        
        <h3>{marker.nombre}</h3>
        <IonList>
            <IonItem>
            <p>
                {marker.descripcion}
            </p>
            </IonItem>
        </IonList>

        <IonList className='Incluye padd-incluye'>
          <IonListHeader>
            <IonLabel className='title-incluye'>{t("pueblosmagicos.atractivos")}</IonLabel>
          </IonListHeader>
          {
            marker.atractivos.map(element =>
              <>
                <IonItem className="terciary">
                  <h5>{element}</h5>
                </IonItem>
              </>  
            )
          }
          
        </IonList>

        <IonList className='Incluye padd-incluye'>
          <IonListHeader>
            <IonLabel className='title-incluye'>{t("pueblosmagicos.festividades")}</IonLabel>
          </IonListHeader>
          {
            marker.festividades.map(element =>
              <>
                <IonItem>
                  <h5>{element}</h5>
                </IonItem>
              </>  
            )
          }
          
        </IonList>

        <IonList className='Incluye padd-incluye'>
          <IonListHeader>
            <IonLabel className='title-incluye'>{t("pueblosmagicos.detalles")}</IonLabel>
          </IonListHeader>


        <IonItem>
            <IonIcon icon={locationOutline} color="success" slot="start"></IonIcon>
            <IonLabel className="ion-text-wrap">{t("pueblosmagicos.ubicacion")}: {marker.ubicacion}</IonLabel>
        </IonItem>

        <IonItem>
            <IonIcon icon={listOutline} color="success" slot="start"></IonIcon>
            <IonLabel className="ion-text-wrap">{t("pueblosmagicos.caracteristicas")}: {marker.caracteristicas}</IonLabel>
        </IonItem>

        <IonItem>
            <IonIcon icon={timeOutline} color="success" slot="start"></IonIcon>
            <IonLabel>{t("arqueologia.tipo")}: {marker.horario}</IonLabel>
        </IonItem>
        <IonItem>
        <IonIcon icon={globeOutline} color="success" slot="start"></IonIcon>
        <IonLabel className="ion-text-wrap">{marker.sitio_web}</IonLabel>
        </IonItem>
        <IonItem>
        <IonIcon icon={pricetagOutline} color="success" slot="start"></IonIcon>
        <IonLabel className="ion-text-wrap">{marker.tipo}</IonLabel>
        </IonItem>
        <IonItem>
            <IonIcon icon={megaphoneOutline} color="success" slot="start"></IonIcon>
            <IonLabel className="ion-text-wrap">{t("pueblosmagicos.promocion")}: {marker.promocion}</IonLabel>
        </IonItem>
        </IonList>

        </IonContent>        </>
    );
};

export default PMagicoModal;